import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { filter } from 'rxjs';

@Component({
  selector: 'a-textarea',
  templateUrl: 'a-textarea.component.html',
  styleUrls: ['a-textarea.component.scss'],
})
export class ATextareaComponent implements OnInit {

  @Input() isSubmitted = true;
  @Input() label = '';
  @Input() grayBg = true;
  @Input() isOptional = false;
  @Input() isDisabled = false;
  @Input() control: any = new FormControl();
  @Output() onBlur = new EventEmitter<any>();
  initValue = null;

  constructor() {
  }

  ngOnInit(): void {
    if (this.control.value) {
      this.initValue = this.control.value;
    }
  }

  checkSave() {
    if (this.control.value !== this.initValue) {
      this.onBlur.emit();
      this.isSubmitted = true;
      this.initValue = this.control.value;
    }
  }

  clear() {
    this.control.reset();
  }

}
